// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/go-around-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/go-around-technique/go-around-technique.js';

mount([g0]);
